import Http from '../request/Http';

export function getKeys(
  page,
  pagesize,
  deptids,
  begintime,
  endtime,
  keyno,
  keyname,
  keytype,
  workername,
  keystatus = -1,
  keymode = -1,
  authstatus = ''
) {
  // TODO: 目前默认使用更新时间筛选 timeflag = 1;
  return Http.get('/keys', {
    deptids,
    keyno,
    keyname,
    workername,
    keymode,
    keytype,
    keystatus,
    begintime,
    endtime,
    timeflag: 1,
    page,
    pagesize,
    authstatus,
  });
}

export function getKey(keyno) {
  return Http.get(`/keys/${keyno}`);
}

export function createKey(key) {
  return Http.post('/keys', key);
}

export function updateKey(key) {
  return Http.put(`/keys/${key.keyid}`, key);
}

export function patchKey(key) {
  return Http.patch(`/keys/${key.keyid}`, key);
}

export function createBlackKey(key) {
  return Http.put(`/keys/blacklist/${key.keyno}?keyflag=${key.keyflag}`);
}

export function setKeyBattery(keyno, battery) {
  return Http.put(`/keys/${keyno}/battery?battery=${battery}`);
}

export function deleteKeys(keyids) {
  return Http.delete(`/keys/${keyids}`);
}

export function outKey(data) {
  return Http.post('/keydatas', data);
}

export function backKey(keyno) {
  // TODO: 这个路径是不是不太科学...
  // return Http.patch(`/keydatas/${keyno}/backtime`, null);
  return Http.post(`/keydatas/${keyno}`, null);
}

export function reportLossOfKey(keyno) {
  return Http.post(`/keys/blacklists/${keyno}`);
}

export function getBlacklists(
  deptids,
  keyno,
  keyname,
  userids,
  begintime,
  endtime,
  page,
  pagesize
) {
  return Http.get('/keys/blacklists', {
    deptids,
    keyno,
    keyname,
    userids,
    begintime,
    endtime,
    page,
    pagesize,
  });
}

export function getBlacklistsInTree() {
  return Http.get('/keys/blacklists/tree');
}

export function deleteFromBlacklists(keyno) {
  return Http.delete(`/keys/blacklists/${keyno}`);
}

export function getKeysTemplate(filename) {
  return Http.downloadByLink('/keys/sheet/template', {}, filename);
}

export function importKeysSheet(deptid, e) {
  return Http.upload('/keys/sheet', { deptid }, e);
}

export function exportKeysSheet(conditions, filename) {
  return Http.download('/keys/sheet', conditions, filename);
}

export function exportBlacklistsSheet(conditions, filename) {
  return Http.download('/keys/blacklists/sheet', conditions, filename);
}

export function getFactoryKeyNo() {
  return Http.get('/keys/factoryno');
}

export function getKeysInTree(type, keystatus) {
  return Http.get(`keys/tree/${type}`, {
    keystatus,
  });
}

export function getKeyByFactoryNo(no) {
  return Http.get(`keys/existence/${no}`);
}
//  钥匙列表，设置应急钥匙时调用    PUT /api/v1/keys/{keyno}/emergency
export function putEmergency(keyno, emergency) {
  return Http.put(`/keys/${keyno}/emergency`, emergency);
}
// 获取通信参数
export function getCommParameter() {
  return Http.get(`/keys/params`);
}
// 更新通信参数
export function updateCommParameter(params) {
  return Http.post('/keys/params', params);
}

// 查询是否存在4G蜂窝钥匙
export function getKeyCellular() {
  return Http.get('/keys/cellular');
}

// 获取系统中注册的钥匙类型
export function getKeyTypes() {
  return Http.get('/keys/keytypes');
}

// 添加钥匙授权记录
export function createKeyDownloadRecord(keyno, authtime, expiretime) {
  return Http.post(`/keys/${keyno}/auth`, { authtime, expiretime });
}

// 获取钥匙部门下的授权人员数量
export function getKeyAuther(keyno) {
  return Http.get(`/keys/${keyno}/auther`);
}

// 清除钥匙授权
export function clearKeyAuth(keyno) {
  return Http.delete(`/keys/${keyno}/auth`);
}
// 设置事件钥匙
export function setEventkey(keyno) {
  return Http.put(`/keys/${keyno}/event`);
}
